module.exports = __webpack_public_path__ + "static/media/hayon3.35bda0aa.jpg";